import { PaintBucket } from 'lucide-react'
import { ProductVariantColor_ } from 'src/api/db/apiProductVariantColor'
import { Image, Tooltip } from 'src/shared/components/ui'
import { cn } from 'src/shared/components/ui/utils'

export const ColorPicker = ({
  selectedColorId,
  productVariantColors,
  onColorChange,
}: {
  selectedColorId: number | null
  productVariantColors: ProductVariantColor_[]
  onColorChange: (colorId: number) => void
}) => {
  return (
    <div
      className="grid grid-cols-4 gap-1 h-[154px] overflow-y-auto border border-gray-200 rounded-lg p-2 bg-white"
      style={{ scrollbarWidth: 'thin' }}
    >
      {productVariantColors?.map((colorVariant) => {
        const { id } = colorVariant
        const illustrations = [...(colorVariant.product_image ?? [])].sort(
          (a, b) => (a?.order ?? 0) - (b?.order ?? 0)
        )
        const image_url = illustrations?.[0]?.image_url
        const isSelected = selectedColorId === id

        return (
          <Tooltip
            key={id}
            content={
              <span className="text-sm flex items-center">
                <PaintBucket className="w-3 h-3 mr-1.5" />
                {colorVariant.color}
              </span>
            }
            delayDuration={300}
          >
            <div className="flex flex-col items-center gap-0.5 z-0">
              <div
                className={cn(
                  'bg-white rounded-sm flex items-center justify-center border border-white relative flex-shrink-0',
                  isSelected && 'border-gray-400'
                )}
              >
                <Image
                  src={image_url || ''}
                  className="w-8 h-8 object-contain cursor-pointer flex-shrink-0 p-1"
                  onClick={() => onColorChange(id)}
                />
                {isSelected && (
                  <div className="absolute inset-0 bg-gray-300/40 rounded-sm flex items-center justify-center" />
                )}
              </div>
              <p
                className={cn(
                  'text-xs text-center truncate w-full max-w-[3.5rem]',
                  isSelected && 'font-medium'
                )}
              >
                {colorVariant.color}
              </p>
            </div>
          </Tooltip>
        )
      })}
    </div>
  )
}
